import { render, staticRenderFns } from "./ReceivingWriteoff.vue?vue&type=template&id=041e45cf&"
import script from "./ReceivingWriteoff.vue?vue&type=script&lang=js&"
export * from "./ReceivingWriteoff.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingWriteoff.vue?vue&type=style&index=0&id=041e45cf&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041e45cf')) {
      api.createRecord('041e45cf', component.options)
    } else {
      api.reload('041e45cf', component.options)
    }
    module.hot.accept("./ReceivingWriteoff.vue?vue&type=template&id=041e45cf&", function () {
      api.rerender('041e45cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/ReceivingWriteoff.vue"
export default component.exports